<template>
  <section class="base-modal" @mousedown.self="$emit('background-clicked')">
    <article
      class="base-modal__content"
      :class="[
        `base-modal__content--size-${size}`,
        `base-modal__content--color-${color}`,
        fixedHeight ? `base-modal__content--fixed-height-${fixedHeight}` : '',
        {
          'base-modal__content--rounded': rounded,
          'base-modal__content--drop-shadow': dropShadow,
        },
        noPadding ? 'base-modal__content--no-padding' : '',
        evenPadding ? 'base-modal__content--even-padding' : '',
      ]"
    >
      <slot />
    </article>
  </section>
</template>

<script>
  export default {
    name: 'BaseModal',
    emits: ['background-clicked'],
    props: {
      size: {
        type: String,
        required: false,
        default: 'md',
        validator: (value) => {
          const SIZES = ['sm', 'md', 'lg', 'tr-modal', 'app'];
          return SIZES.includes(value);
        },
      },
      fixedHeight: {
        type: String,
        required: false,
        default: '',
        validator: (value) => {
          const HEIGHTS = ['sm', 'md', 'lg', 'xl'];
          return !value || HEIGHTS.includes(value);
        },
      },
      color: {
        type: String,
        required: false,
        default: 'normal',
        validator: (value) => {
          const COLORS = ['normal', 'grey-light', 'grey', 'dark-grey'];
          return COLORS.includes(value);
        },
      },
      rounded: {
        type: Boolean,
        required: false,
        default: false,
      },
      dropShadow: {
        type: Boolean,
        required: false,
        default: false,
      },
      noPadding: {
        type: Boolean,
        required: false,
        default: false,
      },
      evenPadding: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    mounted() {
      document.body.classList.add('modal-is-open');
      if(document.getElementById('site-header')) {
        document.getElementById('site-header').classList.add('hide-z-index');
      }
    },
    unmounted() {
      // look into why this needs a set timeout in dataset-upload (TECH DEBT)
      setTimeout(() => {
        document.body.classList.remove('modal-is-open');
        if(document.getElementById('site-header')) {
          document.getElementById('site-header').classList.remove('hide-z-index');
        }
      }, 100);
    },
  };
</script>

<style lang="scss" scoped>
  .base-modal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    padding: 25px;

    background-color: rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(1px);

    z-index: 1000;

    pointer-events: all;

    &__content {
      width: 100%;
      height: fit-content;
      max-height: 100%;
      overflow: auto;

      pointer-events: all;
      user-select: text;
      position: relative;
      &--rounded {
        border-radius: 15px;
      }
      &--drop-shadow {
        box-shadow: 5px 7px 4px 0px #0000004d;
      }

      &--color-normal {
        background-color: #f1f2f3;
      }
      &--color-grey-light {
        background-color: var(--itr-grey-light);
      }
      &--color-grey {
        background-color: var(--itr-grey);
      }
      &--color-dark-grey {
        background-color: #dbdcde;
      }

      &--size-sm {
        max-width: 600px;
        padding: 64px 46px;
      }
      &--size-md {
        max-width: 800px;
        padding: 64px 46px;
      }
      &--size-lg {
        max-width: 1200px;
        padding: 64px 46px;
      }

      &--size-tr-modal {
        max-width: 875px;
        padding: 64px 46px;
      }

      &--size-app {
        width: 100%;
        height: auto;
        padding: 40px 16px 32px 16px;
      }

      &--fixed-height-sm {
        height: 50%;
      }
      &--fixed-height-md {
        height: 75%;
      }
      &--fixed-height-lg {
        height: 85%;
      }
      &--fixed-height-xl {
        height: 100%;
      }

      &--no-padding {
        padding: 0 !important;
      }
      &--even-padding {
        padding: 46px !important;
      }
    }
  }
</style>
